import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {Alert, FormControlLabel, Stack, TextField} from "@mui/material";
import Switch from "@mui/material/Switch";


function AddAllowed(props) {
    const title = 'Dodaj Odbierającego';
    const description = '';

    const [user] = useContext(AuthContext);
    const [fullname, setFullname] = useState('');
    const [phone, setPhone] = useState('');
    const [kinship, setKinship] = useState('');

    function _send() {
        const formData = {
            fullname: fullname,
            kinship: kinship,
            phone: phone,
            is_self: false
        };
        fetch(`/api/children/${props.isOpen}/allowed`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.isOpen} title={title} description={description} send={_send} dismiss={props.dismiss}>
        <Stack direction={'column'} spacing={2}>
                <TextField
                    onChange={(e) => setFullname(e.target.value)}
                    label='Imię i Nazwisko'
                    value={fullname}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setKinship(e.target.value)}
                    label='Stopień Pokrewieństwa'
                    value={kinship}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setPhone(e.target.value)}
                    label='Telefon kontaktowy'
                    value={phone}
                    variant="outlined"
                    fullWidth
                />
        </Stack>
        </StyledModal>);
}
export default AddAllowed;